import http from '@/api/http';

const inventoryItemUsageService = {
  create: inventoryItemUsage => http.post('api/inventory-item-usages', inventoryItemUsage),
};

export default inventoryItemUsageService;
